<template>
<div>
<v-card v-if="selectingidea" @keydown.esc="$emit('isaddpj', false)" style="height:90vh !important;" class="d-flex flex-column px-8">
  <v-card-actions class="justify-center flex-column">
    <v-spacer></v-spacer>
    <h2 class="my-2">新規{{$t('プロジェクト')}}作成</h2>
    <p class="mb-0">新規{{$t('プロジェクト')}}に使う{{$t('アイデア')}}を選択してください</p>
    <v-spacer></v-spacer>
  </v-card-actions>
  <v-card-actions>
    <p class="cloud--text mb-0">{{$t('アイデア')}}一覧</p>
    <v-spacer></v-spacer>
    <p class="mb-0 deepLava--text"><span v-text="pjbasedIdeas.length"></span>件の{{$t('アイデア')}}を選択中</p>
    <v-spacer></v-spacer>
  </v-card-actions>
  <v-card height="75%" flat style="overflow:hidden scroll">
    <v-row>
    <v-col v-for="ide in idea" :key="ide.sort" cols="4">
      <v-card class="mx-auto ma-0 pa-2 d-flex flex-column" outlined elevation="0" height="250" style="border-width: 1.5px; border-color: #707070;"
        @click='usetrueidea[ide.sort]=!usetrueidea[ide.sort], selectidea(ide.sort)'
        :class='{skybar:usetrueidea[ide.sort]}'
        data-testid="clickUseIdea"
      >
        <!--ideaヘッダー-->
        <v-card-actions class="pa-0 d-flex align-center">
          <!--ideaタグ-->
          <v-chip v-if="ide.tag&&ide.tag.title&&aboutLid&&aboutLid.tags&&aboutLid.tags.title&&aboutLid.tags.title.includes(ide.tag.title)" color="#dcdcdc"><v-icon :color="ide.tag.color" size="20">mdi-checkbox-blank-circle</v-icon><p class="mb-0" style="font-size:14px;">&nbsp;{{ ide.tag.title }}</p></v-chip>
          <v-spacer></v-spacer>
          <v-icon v-if="ide.latlngInputLat!=0||false" color="rgba(135,206,250,0.5)" size="30">mdi-map</v-icon>
          <h3 v-if="usetrueidea[ide.sort]" class="deepAqua--text">選択中</h3>
        </v-card-actions>
        <!--idea本文-->
        <v-card-actions color="#2B2B2B" class="d-flex flex-column overflow-y-auto my-0 pt-0 text-left" style="height:70%;" :style="{ 'font-size': ideaFontSize }">
          <p class="mb-0 text-left" style="width:100%;">{{ide.content}}<span class="font-weight-700" style="font-size:10px;" v-if="ide.edit">(編集済み)</span></p>
          <div v-if="ide.quotingId" style="width: 100%;">
            <QuoteBlock :idea="(idea.find(el => el.id === ide.quotingId))" :namelist="namelist" ></QuoteBlock>
          </div>
        </v-card-actions>
        <!--idea画像 @click.native="images=true,dialog_image=ide.ideaImage_large"-->
        <v-img v-if="ide.ideaImage && ide.ideaImage_large" contain max-width="100px" max-height="55px"
          :src="ide.ideaImage" alt="" class="mx-auto">
        </v-img> 
        <v-img v-else-if="ide.ideaImage" contain max-width="100px" max-height="55px"
          :src="ide.ideaImage" alt="" class="mx-auto">
        </v-img>
        <!--ideaフッター-->
        <v-card-actions class="d-flex pa-0 mt-auto">
          <!--idea位置情報-->
          <div v-if="ide.placename">
            <p class="mb-0"><v-icon color="#707070" size="25">mdi-map-marker</v-icon>{{ide.placename}}</p>
          </div>
          <!--idea時間-->
          <div v-if="timeday !== ide.timeday" class="ml-auto">
            <p class="mb-0" style="color:#2B2B2B !important;">{{ide.timeday}}</p>
          </div>
          <div v-else class="ml-auto">
            <p class="mb-0" style="color:#2B2B2B !important;">{{ide.timehour}}</p>
          </div>
        </v-card-actions>
        <v-card-actions class="d-flex justify-space-between pa-0">
          <!--idea作者-->
          <div>
            <div v-if="ide.anonymous||namelist[ide.author]==undefined||namelist[ide.author]==null" style="color:#2B2B2B !important;" class="d-flex">
              <!-- <v-btn small icon @click="profileUid = ide.author,profile = true"> -->
              <v-icon size="25" style="color:rgba(128,128,128,0.4)!important;">mdi-account-circle</v-icon>
              匿名
            </div>
            <div v-else-if="profImageDict[ide.author]==undefined && ide.anonymous!=true" style="color:#2B2B2B !important;" class="d-flex">
              <v-btn small icon disabled>
                <v-icon size="25" style="color:rgba(128,128,128,0.4)!important;">mdi-account-circle</v-icon>
              </v-btn>
              {{namelist[ide.author]}}
            </div>
            <div v-else-if="profImageDict[ide.author]!=undefined && ide.anonymous!=true" style="color:#2B2B2B !important;" class="d-flex">
              <!-- <v-icon size="25" style="color:rgba(128,128,128,0.4)!important;">mdi-account-circle</v-icon> -->
              <v-btn small icon disabled>
                <v-avatar size="25">
                  <img v-bind:src="profImageDict[ide.author]">
                </v-avatar>
              </v-btn>
              {{namelist[ide.author]}}
            </div>
          </div>
          <!--ideaいいね-->
          <div v-if="ide.like&&ide.like.length>=0" class="ma-0">
            <template>
              <v-btn class="ma-0 rounded-pill" elevation="0"  height="25" width="auto" :disabled="true">
                <v-icon size="25"  :color="ide.like.includes(uid) ? 'shallowAqua' : 'shallowCloud'">mdi-thumb-up</v-icon>
                <v-card-text v-if="uid === ide.author || aideauids.some(el => el === ide.id) || aboutLid.lidAdmin.includes(uid) || isAdmin" class="pa-0">
                  <span style="color:#008CFF" v-text="ide.like.length" v-if="ide.like.includes(uid)&&false"></span>
                  <span class="cloud--text" v-text="ide.like.length" v-else></span>
                </v-card-text>
                <v-card-text v-else-if="((ide.like.includes(uid) == false && ide.like.length > 0) || ide.like.length > 1 ) && uid != ide.author" class="pa-0 text-right" style="font-size:10px;">
                  <span v-if="ide.like.includes(uid)"  style="color:#008CFF;">いいね有</span>
                  <span v-else  style="color:#707070;">いいね有</span>
                </v-card-text>
              </v-btn>
            </template>
          </div>
        </v-card-actions>
      </v-card>
    </v-col>
    </v-row>
  </v-card>
  <!--フッター-->
  <v-card-actions class="justify-center">
    <v-chip class="" @click="$emit('isaddpj', false)" data-testid="closeIssuePj" >
      キャンセル
    </v-chip>
    <v-chip  color="#008CFF" dark class="ml-2 px-6" @click="selectingidea= false,issuepj = true" :disabled="pjbasedIdeas.length <= 0" data-testid="gotoIssuePj" >
      次へ
    </v-chip>
  </v-card-actions>
</v-card>

<!--（アイデアを選ぶの続き）タイトル、概要、関連リンクを記入する-->
<v-card v-else-if="issuepj" @keydown.esc="$emit('isaddpj', false)" style="height:90vh !important;">
  <v-card-actions class="justify-center flex-column">
    <v-spacer></v-spacer>
    <h2 class="my-2">新規{{$t('プロジェクト')}}作成</h2>
    <p class="mb-0">新規{{$t('プロジェクト')}}のタイトル・概要を記入してください</p>
    <v-spacer></v-spacer>
  </v-card-actions>
  <v-row class="mt-2 px-0 mx-0" flat style="height: 70vh;">
    <!--採用アイデア表示-->
    <v-col cols="5" style="max-height: 64vh;">
      <p class="text-center mb-0 abyss--text">採用{{$t('アイデア')}}</p>
      <v-card height="80%" flat ideas>
      <v-container style="max-height: 100%" class="overflow-y-auto mt-8">
        <v-row>
          <v-col v-for="ide in idea" :key="ide.sort" v-show="usetrueidea[ide.sort]" cols="12" lg="6">
            <v-card class="mx-auto ma-0 pa-2 d-flex flex-column" outlined elevation="0" height="250" style="border-width: 1.5px; border-color: #707070;" data-testid="clickUseIdea">
              <!--ideaヘッダー-->
              <v-card-actions class="pa-0 d-flex align-center">
                <!--ideaタグ-->
                <v-chip v-if="ide.tag&&ide.tag.title&&aboutLid&&aboutLid.tags&&aboutLid.tags.title&&aboutLid.tags.title.includes(ide.tag.title)" color="#dcdcdc"><v-icon :color="ide.tag.color" size="20">mdi-checkbox-blank-circle</v-icon><p class="mb-0" style="font-size:14px;">&nbsp;{{ ide.tag.title }}</p></v-chip>
                <v-spacer></v-spacer>
                <v-icon v-if="ide.latlngInputLat!=0||false" color="rgba(135,206,250,0.5)" size="30">mdi-map</v-icon>
              </v-card-actions>
              <!--idea本文-->
              <v-card-actions color="#2B2B2B" class="d-flex flex-column overflow-y-auto my-0 pt-0 text-left" style="height:70%;" :style="{ 'font-size': ideaFontSize }">
                <p class="mb-0 text-left" style="width:100%;">{{ide.content}}<span class="font-weight-700" style="font-size:10px;" v-if="ide.edit">(編集済み)</span></p>
                <div v-if="ide.quotingId" style="width: 100%;">
                  <QuoteBlock :idea="(idea.find(el => el.id === ide.quotingId))" :namelist="namelist" ></QuoteBlock>
                </div>
              </v-card-actions>
              <!--idea画像 @click.native="images=true,dialog_image=ide.ideaImage_large"-->
              <v-img v-if="ide.ideaImage && ide.ideaImage_large" contain max-width="100px" max-height="55px"
                :src="ide.ideaImage" alt="" class="mx-auto">
              </v-img> 
              <v-img v-else-if="ide.ideaImage" contain max-width="100px" max-height="55px"
                :src="ide.ideaImage" alt="" class="mx-auto">
              </v-img>
              <!--ideaフッター-->
              <v-card-actions class="d-flex pa-0 mt-auto">
                <!--idea位置情報-->
                <div v-if="ide.placename">
                  <p class="mb-0"><v-icon color="#707070" size="25">mdi-map-marker</v-icon>{{ide.placename}}</p>
                </div>
                <!--idea時間-->
                <div v-if="timeday !== ide.timeday" class="ml-auto">
                  <p class="mb-0" style="color:#2B2B2B !important;">{{ide.timeday}}</p>
                </div>
                <div v-else class="ml-auto">
                  <p class="mb-0" style="color:#2B2B2B !important;">{{ide.timehour}}</p>
                </div>
              </v-card-actions>
              <v-card-actions class="d-flex justify-space-between pa-0">
                <!--idea作者-->
                <div>
                  <div v-if="ide.anonymous||namelist[ide.author]==undefined||namelist[ide.author]==null" style="color:#2B2B2B !important;" class="d-flex">
                    <!-- <v-btn small icon @click="profileUid = ide.author,profile = true"> -->
                    <v-icon size="25" style="color:rgba(128,128,128,0.4)!important;">mdi-account-circle</v-icon>
                    匿名
                  </div>
                  <div v-else-if="profImageDict[ide.author]==undefined && ide.anonymous!=true" style="color:#2B2B2B !important;" class="d-flex">
                    <v-btn small icon disabled>
                      <v-icon size="25" style="color:rgba(128,128,128,0.4)!important;">mdi-account-circle</v-icon>
                    </v-btn>
                    {{namelist[ide.author]}}
                  </div>
                  <div v-else-if="profImageDict[ide.author]!=undefined && ide.anonymous!=true" style="color:#2B2B2B !important;" class="d-flex">
                    <!-- <v-icon size="25" style="color:rgba(128,128,128,0.4)!important;">mdi-account-circle</v-icon> -->
                    <v-btn small icon disabled>
                      <v-avatar size="25">
                        <img v-bind:src="profImageDict[ide.author]">
                      </v-avatar>
                    </v-btn>
                    {{namelist[ide.author]}}
                  </div>
                </div>
                <!--ideaいいね-->
                <div v-if="ide.like&&ide.like.length>=0" class="ma-0">
                  <template>
                    <v-btn class="ma-0 rounded-pill" elevation="0"  height="25" width="auto" :disabled="true">
                      <v-icon size="25"  :color="ide.like.includes(uid) ? 'shallowAqua' : 'shallowCloud'">mdi-thumb-up</v-icon>
                      <v-card-text v-if="uid === ide.author || aideauids.some(el => el === ide.id) || aboutLid.lidAdmin.includes(uid) || isAdmin" class="pa-0">
                        <span style="color:#008CFF" v-text="ide.like.length" v-if="ide.like.includes(uid)&&false"></span>
                        <span class="cloud--text" v-text="ide.like.length" v-else></span>
                      </v-card-text>
                      <v-card-text v-else-if="((ide.like.includes(uid) == false && ide.like.length > 0) || ide.like.length > 1 ) && uid != ide.author" class="pa-0 text-right" style="font-size:10px;">
                        <span v-if="ide.like.includes(uid)"  style="color:#008CFF;">いいね有</span>
                        <span v-else  style="color:#707070;">いいね有</span>
                      </v-card-text>
                    </v-btn>
                  </template>
                </div>
              </v-card-actions>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
      </v-card>
    </v-col>
    <!--記入欄-->
    <v-col class="py-0 overflow-y-auto" cols="7" style="max-height: 66vh;">
      <v-card class="pb-4" flat>
        <v-form ref="submitpjform">
          <p class="my-2 abyss--text">タイトル <span class="abyss--text" style="font-size:10px">(50文字以内 必須)</span></p>
          <v-textarea class="mx-2 pt-0" v-model="pjtitle" no-resize placeholder="Title" rows="1" :rules="[required, pjtitlerule]" hide-details="auto" data-testid="TextPjTitle"></v-textarea>
          
          <p class="mt-2 mb-0 abyss--text">概要 <span class="abyss--text" style="font-size:10px">(必須)</span></p>
          <quill-editor style="height: 10vh" v-model="pjsummary" :rules="[required]" :options="pjsuEditorOption" no-resize rows="1" class="pt-0 mt-2 mb-12 mx-2 quill-editor_1"></quill-editor>

          <p class="my-0 mt-2 abyss--text"> 担当課 <span class="abyss--text" style="font-size:10px">(任意)</span></p>
          <v-textarea class="mx-2 pt-0" v-model="pjinCharge" no-resize placeholder="ここに担当課を入力" rows="1" hide-details="auto"></v-textarea>

          <p class="my-1 abyss--text">参考リンク</p>
          <div class="d-flex flex-column align-start">
            <!-- <v-icon class="mt-0 mb-2" color="#707070" size="25">mdi-link-variant</v-icon>
            <v-text-field v-model="link" label="関連URLを入力(任意)" solo ></v-text-field> -->
            <!-- 「関連URLとそのタイトル」を複数個埋め込めるようにする。モデルはlinksを使う -->
            <div v-for="(link, index) in links" :key="'link-'+index" class="d-flex flex-column align-start">
              <div class="d-flex align-center pb-0">
                <v-text-field v-model="link.url" :label="`関連URL${index+1}`" placeholder="https://..." outlined></v-text-field>
                <v-text-field v-model="link.title" :label="`タイトル${index+1}`" placeholder="リンクのタイトルを入力(任意)"  outlined></v-text-field>
                <v-btn icon @click="links.splice(index, 1)" class="mb-6">
                  <v-icon>mdi-close</v-icon>
                </v-btn>
              </div>
            </div>
            <v-btn class="mb-4 px-10 cloud" dark rounded @click="links.push({url: '', title: ''})">
              <v-icon>mdi-plus</v-icon>URLを追加
            </v-btn>
          </div>

          <p class="my-0 mt-2 abyss--text"> 画像</p>
          <upImage @getImageUrl="getImageUrl" :pjImageForEdit="pjImage"></upImage>
        </v-form>
      </v-card>
    </v-col>
  </v-row>
  <!--フッター-->
  <v-card-actions class="pt-2 justify-center">
    <v-chip class="mr-2" @click="issuepj=false, selectingidea = true">
      採用する{{$t('アイデア')}}を変更する
    </v-chip>
    <v-chip class="deepAqua px-10" dark data-testid="gotoissuepjan" @click="issuepj = false,issuepjan = true" :disabled="pjtitle.length <= 1||pjsummary.length <= 1||pjtitle.length > 50">
      次へ
    </v-chip>  
  </v-card-actions>
</v-card>

<!--（アイデアを選ぶの続き）案を記入する-->
<v-card v-else-if="issuepjan" @keydown.esc="$emit('isaddpj', false)" style="height:90vh !important;">
  <v-progress-linear
    v-if="isSubmitting"
    indeterminate
    color="deepAqua"
    height="6"
  ></v-progress-linear>
  <v-card-actions class="justify-center flex-column">
    <v-spacer></v-spacer>
    <h2 class="my-2">新規{{$t('プロジェクト')}}作成</h2>
    <p class="mb-0">新規{{$t('プロジェクト')}}の案を入力してください</p>
    <v-spacer></v-spacer>
  </v-card-actions>
  <v-card height="70%" flat class="overflow-y-auto">
    <v-row class="mt-2 px-0 mx-0">
      <!--採用アイデア表示-->
      <v-col cols="5" style="max-height: 60vh;">
        <h3 style="font-size:20px" color="#DCDCDC">採用{{$t('アイデア')}}</h3>
        <v-card height="80%" flat ideas>
          <v-container id="scroll-target" style="max-height: 100%" class="overflow-y-auto mt-8">
            <div class="mt-0 pt-0">
              <v-row>
                <v-col v-for="ide in idea" :key="ide.sort" v-show="usetrueidea[ide.sort]" cols="12" lg="6">
                  <v-card class="mx-auto ma-0 pa-2 d-flex flex-column" outlined elevation="0" height="250" style="border-width: 1.5px; border-color: #707070;" data-testid="clickUseIdea">
                    <!--ideaヘッダー-->
                    <v-card-actions class="pa-0 d-flex align-center">
                      <!--ideaタグ-->
                      <v-chip v-if="ide.tag&&ide.tag.title&&aboutLid&&aboutLid.tags&&aboutLid.tags.title&&aboutLid.tags.title.includes(ide.tag.title)" color="#dcdcdc"><v-icon :color="ide.tag.color" size="20">mdi-checkbox-blank-circle</v-icon><p class="mb-0" style="font-size:14px;">&nbsp;{{ ide.tag.title }}</p></v-chip>
                      <v-spacer></v-spacer>
                      <v-icon v-if="ide.latlngInputLat!=0||false" color="rgba(135,206,250,0.5)" size="30">mdi-map</v-icon>
                    </v-card-actions>
                    <!--idea本文-->
                    <v-card-actions color="#2B2B2B" class="d-flex flex-column overflow-y-auto my-0 pt-0 text-left" style="height:70%;" :style="{ 'font-size': ideaFontSize }">
                      <p class="mb-0 text-left" style="width:100%;">{{ide.content}}<span class="font-weight-700" style="font-size:10px;" v-if="ide.edit">(編集済み)</span></p>
                      <div v-if="ide.quotingId" style="width: 100%;">
                        <QuoteBlock :idea="(idea.find(el => el.id === ide.quotingId))" :namelist="namelist" ></QuoteBlock>
                      </div>
                    </v-card-actions>
                    <!--idea画像 @click.native="images=true,dialog_image=ide.ideaImage_large"-->
                    <v-img v-if="ide.ideaImage && ide.ideaImage_large" contain max-width="100px" max-height="55px"
                      :src="ide.ideaImage" alt="" class="mx-auto">
                    </v-img> 
                    <v-img v-else-if="ide.ideaImage" contain max-width="100px" max-height="55px"
                      :src="ide.ideaImage" alt="" class="mx-auto">
                    </v-img>
                    <!--ideaフッター-->
                    <v-card-actions class="d-flex pa-0 mt-auto">
                      <!--idea位置情報-->
                      <div v-if="ide.placename">
                        <p class="mb-0"><v-icon color="#707070" size="25">mdi-map-marker</v-icon>{{ide.placename}}</p>
                      </div>
                      <!--idea時間-->
                      <div v-if="timeday !== ide.timeday" class="ml-auto">
                        <p class="mb-0" style="color:#2B2B2B !important;">{{ide.timeday}}</p>
                      </div>
                      <div v-else class="ml-auto">
                        <p class="mb-0" style="color:#2B2B2B !important;">{{ide.timehour}}</p>
                      </div>
                    </v-card-actions>
                    <v-card-actions class="d-flex justify-space-between pa-0">
                      <!--idea作者-->
                      <div>
                        <div v-if="ide.anonymous||namelist[ide.author]==undefined||namelist[ide.author]==null" style="color:#2B2B2B !important;" class="d-flex">
                          <!-- <v-btn small icon @click="profileUid = ide.author,profile = true"> -->
                          <v-icon size="25" style="color:rgba(128,128,128,0.4)!important;">mdi-account-circle</v-icon>
                          匿名
                        </div>
                        <div v-else-if="profImageDict[ide.author]==undefined && ide.anonymous!=true" style="color:#2B2B2B !important;" class="d-flex">
                          <v-btn small icon disabled>
                            <v-icon size="25" style="color:rgba(128,128,128,0.4)!important;">mdi-account-circle</v-icon>
                          </v-btn>
                          {{namelist[ide.author]}}
                        </div>
                        <div v-else-if="profImageDict[ide.author]!=undefined && ide.anonymous!=true" style="color:#2B2B2B !important;" class="d-flex">
                          <!-- <v-icon size="25" style="color:rgba(128,128,128,0.4)!important;">mdi-account-circle</v-icon> -->
                          <v-btn small icon disabled>
                            <v-avatar size="25">
                              <img v-bind:src="profImageDict[ide.author]">
                            </v-avatar>
                          </v-btn>
                          {{namelist[ide.author]}}
                        </div>
                      </div>
                      <!--ideaいいね-->
                      <div v-if="ide.like&&ide.like.length>=0" class="ma-0">
                        <template>
                          <v-btn class="ma-0 rounded-pill" elevation="0"  height="25" width="auto" :disabled="true">
                            <v-icon size="25"  :color="ide.like.includes(uid) ? 'shallowAqua' : 'shallowCloud'">mdi-thumb-up</v-icon>
                            <v-card-text v-if="uid === ide.author || aideauids.some(el => el === ide.id) || aboutLid.lidAdmin.includes(uid) || isAdmin" class="pa-0">
                              <span style="color:#008CFF" v-text="ide.like.length" v-if="ide.like.includes(uid)&&false"></span>
                              <span class="cloud--text" v-text="ide.like.length" v-else></span>
                            </v-card-text>
                            <v-card-text v-else-if="((ide.like.includes(uid) == false && ide.like.length > 0) || ide.like.length > 1 ) && uid != ide.author" class="pa-0 text-right" style="font-size:10px;">
                              <span v-if="ide.like.includes(uid)"  style="color:#008CFF;">いいね有</span>
                              <span v-else  style="color:#707070;">いいね有</span>
                            </v-card-text>
                          </v-btn>
                        </template>
                      </div>
                    </v-card-actions>
                  </v-card>
                </v-col>
              </v-row>
            </div>
          </v-container>
        </v-card>
      </v-col>
      <v-col cols="7" sm="7">
          <v-card flat>
          <v-form ref="submitpjform">
              <p class="mb-0 abyss--text" style="font-size:22px;">案</p>
              <RichEditor ref="editor" :defaultValue="pjan" />
          </v-form>
          </v-card>
      </v-col>
    </v-row>    
  </v-card>
  <v-card-actions class="justify-center">
    <v-chip class="px-4 mr-2" @click="issuepjan=false, issuepj = true, pjan=$refs.editor.contentEditing">
      前のページに戻る
    </v-chip>
    <v-chip dark color="#008cff" @click="checkBeforeSubmit()" :disabled="isSubmitting||pjtitle.length <= 1||pjsummary.length <= 1">
      {{$t('プロジェクト')}}を開始する
    </v-chip>
  </v-card-actions>
</v-card>

<!-- 案登録ボタン押下時に空だったら案内 -->
<v-dialog v-model="createProWarnContentEmpty" width="70%">
  <v-card>
    <v-card-actions class="justify-center flex-column">
      <v-spacer></v-spacer>
      <h2 class="my-2">新規{{$t('プロジェクト')}}作成</h2>
      <p class="mb-0">案が入力されていません。案を入力してください。</p>
      <v-spacer></v-spacer>
    </v-card-actions>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-chip class="ma-4 pa-4" color="#008CFF" @click="createProWarnContentEmpty=false" dark>閉じる</v-chip>
      <v-spacer></v-spacer>
    </v-card-actions>
  </v-card>
</v-dialog>

<!--プロジェクト作成確認通知-->
<v-dialog v-model="ProSinCheck" width="60%">
    <v-card class="pa-4">
      <v-card-actions class="justify-center flex-column">
        <v-spacer></v-spacer>
        <h2 class="my-2">新規{{$t('プロジェクト')}}作成</h2>
        <p class="mb-0">本当に{{$t('プロジェクト')}}を開始しますか？</p>
        <v-spacer></v-spacer>
      </v-card-actions>
      <v-card-actions class="justify-center">  
        <v-chip class="mr-2" @click="ProSinCheck=false">キャンセル</v-chip>
        <v-chip class="px-4" @click="submitPj(),ProSinCheck= false,isSubmitting=true" color="#008CFF" dark>開始する</v-chip>  
      </v-card-actions>
    </v-card>
</v-dialog>

<!--プロジェクト開始通知画面-->
<v-dialog v-model="ProSinChecked" width="60%">
    <v-card class="pt-4 pb-2">
        <v-card-text class="text-center px-8 py-2 text-h5 font-weight-bold" style="color:#0F0101;">この{{$t('プロジェクト')}}は作成されました</v-card-text>
        <v-card-actions class="pt-0">
            <v-spacer></v-spacer>
            <v-chip class="mt-4 mx-2 px-4" @click="ProSinChecked=false,$emit('isaddpj', false)" color="#66BAFF" dark>確認</v-chip>
        </v-card-actions>
    </v-card>
</v-dialog>
<log_createprj ref="log_createprj"/>    
</div>

</template>

<script>
import firebase from "firebase/app"
import "firebase/firestore"
import log_createprj from "../profile/log_createprj.vue"
import QuoteBlock from '../../components/idea/QuoteBlock.vue'
import RichEditor from '../../components/RichEditor.vue'
import upImage from '../../components/project/project_upImage.vue'
export default{
  props:{
    lidusers: Array
  },
  components:{
    upImage,
    log_createprj,
    QuoteBlock,
    RichEditor
  },
  data: (vm) => ({
      offsetTop: 0,
      idea:[],
      aideauids:[],
      ideaFontSize: "18px",
      //dialog
      selectingidea: true,
      issuepj: false,
      issuepjan: false,
      ProSinCheck: false,
      ProSinChecked: false,
      createProWarnContentEmpty: false,

      isSubmitting: false,

      usetrueidea: [],
      pjbasedIdeas: [],
      
      pjtitle:'',
      pjsummary:'',
      links: [],
      pjinCharge:'',
      pjan:'',

      date: null,
      yyyy: null,
      mm: null,
      dd: null,
      hh: null,
      mi: null,
      se: null,
      ms: null,
      todayy: null,
      timeday: null,

      pjImage:null,
      pjImage_large:null,
      
      pjtitlerule: v => v.length <= 50 || '入力は50文字までです',
      required: v => !!v || "必ず入力してください",
      pjEditorOption: {
          modules: {
              toolbar: [
              [{ 'header': [1, 2, 3, 4, 5, 6, false] }],
              //[{ 'size': ['small', false, 'large', 'huge'] }],  // custom dropdown
              ['bold', 'italic', 'underline', 'strike'],        // toggled buttons
              //['blockquote', 'code-block'],
              //[{ 'header': 1 }, { 'header': 2 }],               // custom button values
              //[{ 'list': 'ordered'}, { 'list': 'bullet' }],
              //[{ 'script': 'sub'}, { 'script': 'super' }],      // superscript/subscript
              //[{ 'indent': '-1'}, { 'indent': '+1' }],          // outdent/indent
              //[{ 'color': [] }, { 'background': [] }],          // dropdown with defaults from theme
              //[{ 'font': [] }],
              [{ 'align': [] }],
              ['image'],
              //['clean']                                         // remove formatting button
              ]
          },
          placeholder: "ここに入力してください",
      },
      pjsuEditorOption:{
          modules: {
              toolbar: [
              [{ 'header': [1, 2, 3, 4, 5, 6, false] }],
              //[{ 'size': ['small', false, 'large', 'huge'] }],  // custom dropdown
              ['bold', 'italic', 'underline', 'strike'],        // toggled buttons
              //['blockquote', 'code-block'],
              //[{ 'header': 1 }, { 'header': 2 }],               // custom button values
              //[{ 'list': 'ordered'}, { 'list': 'bullet' }],
              //[{ 'script': 'sub'}, { 'script': 'super' }],      // superscript/subscript
              //[{ 'indent': '-1'}, { 'indent': '+1' }],          // outdent/indent
              //[{ 'color': [] }, { 'background': [] }],          // dropdown with defaults from theme
              //[{ 'font': [] }],
              [{ 'align': [] }],
              //['clean']                                         // remove formatting button
              ]
          },
          placeholder: "ここに入力してください",
      },
  }),
  mounted(){
    this.db = firebase.firestore() // dbインスタンスを初期化
    this.today()
    this.getIdea()
  },
  methods: {
    onScroll (e) { //スクロール
      this.offsetTop = e.target.scrollTop
    },
    resetpj() {
      this.usetrueidea=[]
      this.pjtitle = ''
      this.pjsummary= ''
      this.links=[]
      this.pjinCharge=''
      this.pjan= ''
    },
    //プロジェクト新規作成関係の関数
    getIdea(){ //アイデア取得
      let self = this, oneidea = {}
      this.idea = []
      let collection = this.db.collection("0").doc(this.$route.params.id).collection("idea").where("isActive", "==", true).where("isHidden", "==", false).orderBy('sort', 'asc')
      collection.get().then((querySnapshot) => {
        querySnapshot.forEach((doc) => {
          //console.log(`${doc.id} => ${doc.data()}`)
          oneidea = doc.data()
          self.$set(oneidea,"id",doc.id)
          self.idea.push(oneidea)
        })
        self.idea = self.idea.slice().reverse()
      })
      if(this.isAuthed){
        let collection2 = this.db.collection("0").doc(this.$route.params.id).collection("liduser").doc(self.uid).collection("aidea")
        collection2.get().then((querySnapshot) => {
          querySnapshot.forEach((doc) => {
            //console.log(`${doc.id} => ${doc.data()}`)
            self.aideauids = doc.data().aideas || []
          })
        })         
      }
      //console.log("このprojectのアイデア",this.idea)
    },
    selectidea(id){ //採用されたアイデアを選択する
      if(this.usetrueidea[id]){
        //usetrueideaでtrueになったアイデアIDをpjbasedIdeasに登録し、usetrueideaでfalseになったアイデアIDをpjbasedIdeasから削除する
        this.pjbasedIdeas = this.pjbasedIdeas.filter(n => n !== id)
        this.pjbasedIdeas.push(id)
        //console.log(this.pjbasedIdeas,this.usetrueidea,this.usetrueidea[id])
      }
      else{
        this.pjbasedIdeas = this.pjbasedIdeas.filter(n => n !== id)
        //console.log(this.pjbasedIdeas,this.usetrueidea,this.usetrueidea[id])
      }
    },
    checkBeforeSubmit() {
			if (this.$refs.editor.contentEditing.length) {
        this.ProSinCheck = true
			} else {
				this.createProWarnContentEmpty = true
			}
		},
    submitPj() {//プロジェクト登録する
      if(this.$refs.submitpjform.validate()) {
        let self = this
        this.today()
        this.links.splice(0, this.links.length)
        // Pj登録
        this.db.collection("0").doc(this.$route.params.id).collection("project").add({
          author: this.uid,
          currentName: this.currentName,          
          title: this.pjtitle,
          summary: this.pjsummary,
          links: this.linksParser(this.links),
          inCharge:this.pjinCharge,
          basedIdeas: this.pjbasedIdeas,
          createdAt: firebase.firestore.FieldValue.serverTimestamp(),
          updatedAt: firebase.firestore.FieldValue.serverTimestamp(),
          isActive: true,
          condition: "dis",
          sort: this.todayy,
          isStartVote: false,
          admin: [this.uid],
          pjAdmin: [this.uid],
          pjImage: this.pjImage,
          pjImage_large: this.pjImage_large,
          commentCount: 0,
        }).then(async function(docRef) {
          // 保存に成功した時
          // await self.submitpro(docRef.id)
          // await self.submitPjUsers(docRef.id)
          // await self.$refs.log_createprj.creprjlog(self.$route.params.id, docRef.id, self.pjtitle)
          // 上記3つをPromise.allでまとめる
          Promise.all([
            self.submitpro(docRef.id),
            self.submitPjUsers(docRef.id),
            self.$refs.log_createprj.creprjlog(self.$route.params.id, docRef.id, self.pjtitle)
          ]).then(() => {
            self.isSubmitting = false
            self.$emit('isaddpj', false)
            self.resetpj()
            //self.$router.go({path: self.$router.currentRoute.path, force: true})
          })
        })
      }
    },
    submitpro: async function(id){ //案を登録する
      let self = this
      this.today()
      const lidId = this.$route.params.id
      
      await this.db.collection("0").doc(lidId).collection("project").doc(id).collection("proposals").add({
        author: this.uid,
        currentName: this.currentName,
        createdAt: firebase.firestore.FieldValue.serverTimestamp(),
        sort: this.todayy, 
        title: `${this.yyyy}-${this.mm}-${this.dd}`,
        amends: null
      }).then(async function(docRef) {
        await self.$refs.editor.submitContent(`projects/${lidId}/${id}/proposal/${docRef.id}.html`).then(async function(){
          
        })
        // 保存に成功した時
        //console.log("proposals Document written with ID: ", docRef.id)
      }).catch(function(error) {
        // 保存に失敗した時
        console.error("proposals Error adding document: ", error)
        alert("Error!:"+error)
      })
    },
    submitPjUsers: async function(id){// プロジェクトユーザー登録
      let self = this
      this.today()
      //console.log("PJ新規ユーザ登録手続き")
      await self.db.collection("0").doc(self.$route.params.id).collection("project").doc(id).collection("user").doc(this.uid).set({
        isActive:true,
        uid: this.uid,
        currentName: this.currentName, 
        sort: this.todayy,
        isPermitDele: true,
        createdAt: firebase.firestore.FieldValue.serverTimestamp(),
        updatedAt: firebase.firestore.FieldValue.serverTimestamp()
      }).then(function(docRef) {
        //console.log("USERs Document written with ID: ", docRef.id)
        //console.log("PJユーザ登録完了")
      }).catch(function(error) {
        console.error("PJユーザ登録失敗: ", error)
        alert("Error!:"+error)
      })                
    },
    getImageUrl(pjImage, pjImage_large){
      this.pjImage = pjImage;
      this.pjImage_large = pjImage_large;
    },
    toDoubleDigits(num) {
      num += "";
      if (num.length === 1) {
        num = "0" + num;
      }
      return num; 
    },
    today(){
      // 日付をYYYY/MM/DD HH:DD:MI:SS形式で取得
      this.date = new Date();
      this.yyyy = this.date.getFullYear();
      this.mm = this.toDoubleDigits(this.date.getMonth() + 1)
      this.dd = this.toDoubleDigits(this.date.getDate())
      this.hh = this.toDoubleDigits(this.date.getHours())
      this.mi = this.toDoubleDigits(this.date.getMinutes())
      this.se = this.toDoubleDigits(this.date.getSeconds())
      this.ms = this.toDoubleDigits(this.date.getMilliseconds())
      //console.log(this.todayy)
      this.todayy = this.yyyy + this.mm + this.dd + this.hh + this.mi + this.se + this.ms
      this.timeday= this.mm+"/"+this.dd
    },
    linksParser(links) {
      // linkのurlが存在し、かつ安全かどうかをチェック
      return (
        links
          .map((link) => {
            return {
              ...link,
              url:
                link.url && /^https?:/.test(link.url)
                  ? link.url
                  : `https://${link.url}`,
            };
          })
          .filter((link) => /^https?:/.test(new URL(link.url).protocol)) || []
      );
    },
  },
  computed:{
    namelist(){
      return this.$store.state.namelist
    },
    profImageDict(){
      return this.$store.state.profImageDict
    },
    uid() {
      return this.$store.state.auth?.user?.uid || '';
    },
    currentName() {
      return this.$store.state.auth.user.displayName;
    },
    isAdmin(){
      return this.$store.state.isAdmin
    },
    isAuthed() {
      return this.$store.state.auth?.isAuthed;
    },
    lid(){
      return this.$store.state.lid
    },
    alid(){
      return this.$store.state.alid
    },
    aboutLid() {
      if (this.$store.state.lid.some((u) => u.id === this.$route.params.id)) {
          return this.$store.state.lid.filter((u) => u.id === this.$route.params.id)[0]
        } else if (this.$store.state.alid.some((u) => u.id === this.$route.params.id)) {
          return this.$store.state.alid.filter((u) => u.id === this.$route.params.id)[0]
        } else {
          return null
        }
    },
  }
}
</script>
<style scoped>
.deepaquaFont{
  color: #008CFF;
}
.quill-editor_1{
  height: 150px;
}
.skybar{
  background-color: white !important;
  background-size: contain;
  border: medium solid #008CFF !important;
}
.cloudFont{
  color:#707070;
}
.defaultcolor{
  background-color: #cce8ff;
}
.redcolor{
  background-color: #ff8796;
}
.greencolor{
  background-color: #b6e3ba;
}
.yellowcolor{
  background-color: #ffb336;
}
.ideafooter{
  position: absolute;
  top: 75%;
  width: 98%;
}
.ideas::-webkit-scrollbar { 
  display: none;
}
*{
  font-family:mplus-2c-medium;
}
</style>